var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, isValidElement, cloneElement, Children, } from 'react';
var FunnelRadioButtonGroup = function (_a) {
    var defaultValue = _a.defaultValue, name = _a.name, onChange = _a.onChange, defaultChecked = _a.defaultChecked, props = __rest(_a, ["defaultValue", "name", "onChange", "defaultChecked"]);
    var _b = useState(''), selected = _b[0], setSelected = _b[1];
    var handleOnChange = function (e) {
        if (onChange) {
            onChange(e);
        }
        setSelected(e.target.value);
    };
    var addPropsToRadioItem = function (children) {
        var childPropsChildren;
        var newChildren = Children.map(children, function (child) {
            if (!isValidElement(child))
                return child;
            if (child.props && child.props.children) {
                childPropsChildren = addPropsToRadioItem(child.props.children);
            }
            else {
                childPropsChildren = null;
            }
            if (child.props.__type === 'FunnelRadioButton') {
                var _a = child.props, value = _a.value, children_1 = _a.children, others = __rest(_a, ["value", "children"]);
                return cloneElement(child, __assign({ key: "radio-".concat(name, "-").concat(value), name: "radio-".concat(name, "-").concat(value), checked: value === selected, fadeOut: selected && value !== selected, defaultChecked: !selected && value === defaultValue, onChange: handleOnChange, children: children_1 }, others));
            }
            else {
                return cloneElement(child, {}, childPropsChildren);
            }
        });
        return newChildren;
    };
    var childrenWithProps = addPropsToRadioItem(props.children);
    return React.createElement(React.Fragment, null, childrenWithProps);
};
export default FunnelRadioButtonGroup;
//# sourceMappingURL=FunnelRadioButtonGroup.js.map